import React from "react";
import styles from "./KpiCard.module.scss";

const KpiCard = ({ icon, value, label }) => {
  return (
    <div className={styles.card}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.info}>
        <span className={styles.value}>{value}</span>
        <span className={styles.label}>{label}</span>
      </div>
    </div>
  );
};

export default KpiCard;
